import type { ApiSitterSearchConfig } from '@app/constants/ApiTypes/internalEntities'

import { createSelector } from '@app/utils/createSelector'

import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callInternalApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { profileRegionSlugResultSelector } from './profile_place'

export const searchConfigSlice = createReduxSlice<SliceState<ApiSitterSearchConfig>>('sitter_search_configs')

export const sitterSearchConfigResultSelector = createSelector([searchConfigSlice.selector, profileRegionSlugResultSelector], (slice, slugResult) =>
  createLoadable(c => {
    const slug = c.unwrap(slugResult)
    const hash = slug
    return withCheckedSliceState(c, {
      sliceState: slice,
      slice: searchConfigSlice,
      load: async dispatch => {
        const { getSitterSearchConfigs } = await import('@app/packages/internalApi/actions/sitter_search_configs')
        const resp = await dispatch(callInternalApi(getSitterSearchConfigs({ region_slug: hash })))
        return resp.data
      },
    })
  })
)
